module.exports = __webpack_public_path__ + "static/media/unchecked.a39be25e.svg";